<template lang="html">
    <div class="client-settings__card">
        <h2 class="header-2">
            Imagine și videoclip profil
        </h2>
        
        <FormUpdateImageAndVideo  
            @activeButton="activeNextStep = $event"
        />
    </div>
</template>

<script>

import FormUpdateImageAndVideo from '@/components/forms/Settings/ImageAndVideo'

import { mapActions } from 'vuex'

export default {
    components: {
        FormUpdateImageAndVideo
    },
    data() {
        return {
            activeNextStep: false
        };
    }
}
</script>

